import { setGTMData } from '@/services/Helper';
import { removeTemporaryAccessToken, setAccessToken } from '@/services/AccessToken';
import { signInActionTypes } from './constants';

interface SignInState {
	loading: boolean;
	token: string;
	userId: number | null;
	socialLoading?: boolean;
}

const initialState: SignInState = {
	loading: false,
	token: '',
	userId: null,
};

export default function signInReducer(state = initialState, action: any) {
	const { type, payload } = action;
	const { token } = payload || {};

	switch (type) {
		case signInActionTypes.LOGIN_REQUEST:
			return {
				...state,
				loading: true,
			};

		case signInActionTypes.LOGIN_SUCCESS:
			setAccessToken(token);
			removeTemporaryAccessToken();

			setGTMData({
				event: 'successfulLogin',
			});

			return {
				...state,
				token: '',
				userId: null,
				loading: false,
				socialLoading: false,
			};

		case signInActionTypes.LOGIN_ERROR:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
